import { render, staticRenderFns } from "./PupUP.vue?vue&type=template&id=4edc6a1e&scoped=true&"
import script from "./PupUP.vue?vue&type=script&lang=js&"
export * from "./PupUP.vue?vue&type=script&lang=js&"
import style0 from "./PupUP.vue?vue&type=style&index=0&id=4edc6a1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edc6a1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
